<div class="container-xxl">
  <div class="row">
    <div class="wrapper">
      <mb-media
        *ngIf="media"
        [media]="media"
        [autoplay]="true"
        [muted]="true"
        [controls]="false"
        [loop]="true"
        [hideTitles]="true"
        [playsInline]="true"
      ></mb-media>
      <div #contentWrapper class="content" [class.space-bottom]="fuelLabel" [ngClass]="innerLayout">
        <ng-container *ngTemplateOutlet="countdownTemplate; context: { rear: !isRearCountdown }" />
        <div #titleContainer class="title-container" [class.hide-border]="!subtitle">
          <h2 class="title-wrapper h4 content-item">{{ title }}</h2>
          <span *ngIf="titleHash" class="title-hash-wrapper h4 content-item">{{ titleHash }}</span>
        </div>
        <div #subtitleContainer class="subtitle-container">
          <span *ngIf="subtitle" class="content-item">{{ subtitle }}</span>
        </div>
        <ng-container *ngTemplateOutlet="countdownTemplate; context: { rear: isRearCountdown }" />
      </div>
      <div *ngIf="fuelLabel" class="fuel-label-container copy-s" [innerHTML]="fuelLabel"></div>
    </div>
  </div>
</div>

<ng-template #countdownTemplate let-rear="rear">
  <div
    *ngIf="rear"
    #countdownContainer
    [ngClass]="isRearCountdown ? 'rear-countdown-container' : 'front-countdown-container'"
  >
    <mb-countdown
      *ngIf="withCountdown && !isFinished && countdownDate"
      class="content-item"
      [countdownTo]="countdownDate"
      [countdownType]="countdownType"
      [countdownLabel]="countdownLabel"
      (finished)="finished()"
    ></mb-countdown>
  </div>
</ng-template>
